module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/todo-outreach-48521fd399a58dd1f8920e44d074638b.svg";